module.exports = __webpack_public_path__ + "static/media/iconfinder_twitter_circle_color_107170.da43cdfd.svg";